<template>
  <div
    class="home">
    <!--<ljb-header-->
    <!--:title="title"-->
    <!--:back-arrow="BackArrow"/>-->
    <swipe-banner
      id="anchor-0"
      @onClick="onBannerClick" />
    <div class="consult">
      <!-- <module-title :module-title = "moduleTitle"/> -->
      <list-field/>
    </div>
    <!-- <common-problems/> -->
    <dynamic-list/>
    <div v-if="isFS365" class="linege" />
    <div v-if="isFS365" class="bottom-banner-box">
      <div
        class="bottom-banner"
        @click="jumpToKhbd">
        <img src="https://cdn.51ljb.cn/ljb_icon_fs365_khbd.png">
      </div>
      <div
        class="bottom-banner"
        @click="jumpToMfd">
        <img src="https://cdn.51ljb.cn/ljb_icon_fs365_qmdf.png">
      </div>
    </div>

    <!-- <div class="linege" />
    <div class="lawyer-video">
      <div class="video-text" @click="goLink('Institute')">
        <div class="face">平台税务师展示</div>
        <div class="one">为您一对一的贴心服务<div class="consulting">去咨询&nbsp;></div></div>
      </div>
      <div class="video-img">
        <img src="https://cdn.51ljb.cn/ljb_icon_fsjs_logo.png">
      </div>
    </div> -->
    <div class="linege" />
    <list-serivce id="anchor-1" />
    <div class="linege" />
    <div class="lawyer-video">
      <div class="video-text" @click="goLink('video')">
        <div class="face">视频律师咨询</div>
        <div class="one">更便捷&nbsp;更贴心&nbsp;更亲切<div class="consulting">去咨询></div></div>
      </div>
      <div class="video-img">
        <img src="https://cdn.51ljb.cn/ljb_icon_video.png">
      </div>
    </div>
    <!-- <card-list/> -->
    <div class="linege" />
    <list-lawyer />
    <div class="linege" />
    <list-information />
    <!-- <div class="bottom-banner" @click="jumpTo">
      <img src="https://cdn.51ljb.cn/ljb_icons_bottom_banner2.png">
    </div> -->
    <div v-if="member && member.length > 0" class="fixed-mylawyer2" @click="goLawyerAi">
      <img src="https://cdn.51ljb.cn/ljb_icons_home_ailawyer.png">
    </div>
    <div v-if="remainingTime" class="fixed-mylawyer" @click="goLawyerVc">
      <div>距离视频律师咨询开始</div>
      <div>还有{{ remainingTime }}</div>
      <!-- <img src="https://cdn.51ljb.cn/ljb_icons_home_mylawyer.png"> -->
    </div>
    <popup-coupon
      :show-coupon="isShowCoupon"
      :coupon-img = "couponImg"
      @getCoupon="getCouponState"
      @closeCoupon="closeCoupon"/>
    <cooperation-logo v-show="showLogo"/>

    <LjbNotpay ref="ljbnotpay" />
    <ljb-footer/>

    <div
      v-if="isShowNew"
      class="newPeople">
      <div
        :class="step ? 'newPeople_box2':''"
        class="newPeople_box">
        <img
          v-if="!step"
          class="yd1"
          src="https://cdn.51ljb.cn/ljb_icon_yd1_new.png"
          alt=""
          @click="goAnchor('1')">
        <img
          v-if="step"
          class="yd1"
          src="https://cdn.51ljb.cn/ljb_icon_yd2.png"
          alt=""
          @click="isShowNew = false, guideComplete('0')">
        <img
          class="line"
          src="https://cdn.51ljb.cn/ljb_icon_yd_line.png"
          alt="">
      </div>
      <!-- <img class="line" src="https://cdn.51ljb.cn/ljb_icon_yd_line.png" alt=""> -->
      <div class="newPeople_bg">
        <p v-if="!step" @click="goAnchor('1')">点击领域后开始电话咨询</p>
        <!-- <p v-if="!step">点击后可进入咨询功能</p> -->
        <p v-if="step" @click="isShowNew = false, guideComplete('0')">点击热门服务为您解决法律问题</p>
        <!-- <p v-if="step">点击后可进入服务功能</p> -->
      </div>
      <div class="newPeople_button">
        <div
          v-if="!step"
          class="close"
          @click="isShowNew = false, guideComplete('0')">跳过</div>
        <div
          v-if="!step"
          class="next"><a @click="goAnchor('1')">下一步</a></div>
        <div
          v-if="step"
          class="next"
          @click="isShowNew = false, guideComplete('0')">我知道啦</div>
      </div>
    </div>
  </div>

</template>

<script>
import SwipeBanner from '@/components/swiper/SwipeBannerNew'
import ModuleTitle from '@/components/title/ModuleTitle'
import ListField from '@/components/list/ListField'
import ListSerivce from '@/components/list/ListServiceNew'
import ListLawyer from '@/components/list/ListLawyer'
import ListInformation from '@/components/list/ListInformation'
import SwipeActive from '@/components/swiper/SwipeActive'
import LjbFooter from '@/components/common/LjbFooter'
import LjbNotpay from '@/components/common/LjbNotpay'
import LjbHeader from '@/components/LjbHeader'
import DynamicList from '@/components/views/DynamicList'
import PopupConsulting from '@/components/popup/consulting/PopupConsulting'
import {mapGetters} from 'vuex'
import PopupCoupon from '@/components/popup/PopupCoupon'
import CardItems from '../components/views/CardItems'
import CardList from '../components/views/CardList'
import CooperationLogo from '@/components/views/CooperationLogo'
import CommonProblems from '../components/views/CommonProblems'
import Request from '@/libs/request/http'
import { Toast, Dialog } from 'vant'
import Vue from 'vue'

Vue.use(Dialog)

export default {
  name: 'Home',
  components: {
    CommonProblems,
    CooperationLogo,
    CardItems,
    CardList,
    PopupCoupon,
    PopupConsulting,
    DynamicList,
    LjbHeader,
    LjbFooter,
    SwipeActive,
    ListSerivce,
    ListField,
    ModuleTitle,
    ListLawyer,
    LjbNotpay,
    ListInformation,
    SwipeBanner},
  data () {
    return {
      title: '律家保-您的私家法税顾问',
      BackArrow: true,
      currentIndex: '0',
      userInfo: {},
      isShowCzh: true, // 是否显示车智慧图标
      showPopup: true,
      popupInfo: {
        title: '导出成功',
        text: '您将在3个工作日内收到',
        subText: '请耐心等待'
      },
      moduleTitle: {
        title: '选择领域 点击咨询',
        text: ''
      },
      isShowAlert: false,
      isShowCoupon: false,
      couponImg: '',
      popupConsult: {
        title: '交通出行',
        text: '10元/分钟',
        typeList: [{
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }, {
          name: '交通出行'
        }]
      },
      IsHaveOrder: '',
      total: 0,
      step: 0,
      isShowNew: false,
      isGuide: 0,
      remainingTime: '',
    }
  },
  computed: {
    ...mapGetters('User', ['getUserInfo', 'getShowLogin', 'getCoupon']),
    showCoupon () {
      let userInfo = this.getUserInfo
      let isShow = true
      if (userInfo) {
        isShow = userInfo.showCoupon > 0
      }
      if (this.getShowLogin) {
        isShow = false
      }
      if (this.$utils.getChannel() !== 'czh') {
        isShow = false
      }
      return isShow
    },
    member () {
      const member = (this.userInfo && this.userInfo.memberEntityList) || []
      return member
    },
    // productCode () {
    //   return this.member && this.member.productCode
    // },
    isFS365 () {
      console.log(this.member, 'this.userInfo.memberEntityList')
      for (let i = 0; i < this.member.length; i++) {
        if (this.member[i].productCode === 'MC20026') {
          return true
        }
      }
      return false
    },
    showLogo () {
      let isShow = false
      if (this.$utils.getChannel() === 'czh') {
        isShow = true
      }
      return isShow
    }
  },
  watch: {
    getUserInfo () {
      if (this.getCoupon && this.getUserInfo) {
        this.getCouponAction()
      }
      if (this.getUserInfo) {
        Request.get('user/userInfo').then((res) => {
          this.userInfo = res.data
        })
      }
    }
  },
  mounted () {
    console.log(this.getUserInfo)
    // Toast({message: '您有10条未读消息，进入我的->消息中心查看', duration: 6000, position: 'bottom'});
    this.couponShow()
    this.$utils.clearOrderInfo()
    this.IsHaveOrder = sessionStorage.getItem('IsHaveOrder') || 'false'
    if (this.IsHaveOrder === 'false') {
      this.getOrderList()
    }
    if (this.getUserInfo) {
      Request.get('user/userInfo').then((res) => {
        console.log('this.userInfo = res.data', res.data)
        this.userInfo = res.data
        this.isGuide = res.data.isGuide
        this.isShowNew = this.isGuide ? 0 : 1
        // this.isShowNew = 1
      })
      this.getVcOrderDate()
    }
  },
  methods: {
    check () {
      this.isShowAlert = true
    },
    jumpToKhbd () {
      location.href = 'https://app.51ljb.cn/h5/simplifyinfo/#/Information?channel=fs365&channelCode=fs365&tagIds=3cdfad5064a34b9d9788ce00eef38411'
      // this.$router.push({path: '/postersHaibao'})
    },
    jumpToMfd () {
      location.href = 'https://app.51ljb.cn/h5/simplifyinfo/#/Information?channel=fs365&channelCode=fs365&tagIds=49ce68b3381a447e959b5f66b597db77'
      // this.$router.push({path: '/postersThr'})
    },
    jumpTo () {
      Toast('建设中')
    },
    goLink (path) {
      this.$router.push(path)
      document.querySelector('#anchor-0').scrollIntoView()
    },
    getVcOrderDate() {
      this.$get.vcOrderDate({}).then(res => {
        if (res.data.appointmentDate === '' || !res.data.appointmentDate) return
        this.remainingTime = this.formatTime(res.data.appointmentDate)
      })
    },
    formatTime(time) {
      var day = 0, hour = 0, minute = 0
      let dateDiff = new Date(time).getTime() - new Date().getTime()
      let hours = dateDiff/(3600*1000)
      let minutes = (hours*60).toFixed(0)
      if (hours >= 24) {
        day = Math.floor(hours/24)
      }
      hour = Math.floor(hours - day*24) > 0 ? Math.floor(hours - day*24) : 0
      if (minutes <= 0) {
        minute = 0
      } else if (minutes%60 === 0) {
        minute = 59
      } else {
        minute = minutes%60
      }
      return day+'天'+hour+'小时'+minute+'分钟'
    },
    // 点击获取优惠券
    getCouponState () {
      if (!this.getUserInfo) {
        this.$store.commit('User/setShowLogin', true)
        this.isShowCoupon = false
        this.$store.commit('User/setCoupon', true)
        return
      }
      this.getCouponAction()
    },
    guideComplete (id) {
      this.$get.updateGuide({
        guideStatus: '1'
      }).then(res => {
        console.log(res)
        document.querySelector('#anchor-' + id).scrollIntoView()
      })
    },
    // 调用接口获取优惠券
    getCouponAction () {
      this.$post.getActive().then(res => {
        this.$toast(res.msg)
        this.isShowCoupon = false
        setTimeout(() => {
          this.$router.push('coupon')
        }, 1500)
        this.$store.commit('User/setCoupon', null)
      }).catch(res => {
        this.$router.push('coupon')
      })
    },
    // 锚点跳转
    goAnchor (id) {
      document.querySelector('#anchor-' + id).scrollIntoView()
      this.step = 1
    },
    // 是否显示优惠券
    couponShow () {
      this.$post.whichActive().then(res => {
        if (res.data) {
          if (res.data.img) {
            this.couponImg = res.data.img
            this.isShowCoupon = true
          }
        }
      })
    },
    closeCoupon () {
      this.isShowCoupon = false
    },
    onBannerClick (item) {
      if (item && item.url === 'show_coupon') {
        this.getCouponState()
      }
    },
    goLawyerAi () {
      Dialog.confirm({
        title: '温馨提示',
        message: '本服务生成内容由AI生成，我们不能保证生成内容无误、准确和完整。相关内容仅为您提供辅助参考，并不代表法律专业意见，不能代替法律专业人员的解答。',
        messageAlign: 'left',
        confirmButtonColor: '#b98727'
      }).then(() => {
        // on confirm
        location.href = `https://app.51ljb.cn/app-h5/aizx/index.html?token=${this.$store.state.User.userInfo.token}`
      }).catch(() => {
        // on cancel
      })
    },
    goLawyerVc () {
      this.$router.push('/VideoList')
    },
    getOrderList () {
      this.$get.unPayOrder({
      }).then((res) => {
        this.total = res.data.length || 0
        if (this.total > 0 && this.IsHaveOrder === 'false') {
          sessionStorage.setItem('IsHaveOrder', 'true')
          this.$refs.ljbnotpay.open()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .consult{
    background: #fff;
  }
  .home{
    background: #fff;
    padding-bottom: 60px;
    overflow: hidden;
  }
  .linege{
    width: 100%;
    height: 8px;
    background: #f7f7f7;
  }
  .bottom-banner-box{
    width: 100%;
    padding: $padding 12px;
    box-sizing: border-box;
  }
  .bottom-banner{
    // padding:0 $padding;
    box-sizing: border-box;
    width: 167px;
    height: 102px;
    display: inline-block;
    // margin-bottom: 15px;
    >img{
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
  .bottom-banner:first-child{
    margin-right: 11px;
  }
  .fixed-mylawyer2{
    position: fixed;
    right: 15px;
    top: 400px;
    width: 64px;
    text-align: center;
    >img {
      width: 64px;
    }
  }
  .fixed-mylawyer{
    position: fixed;
    right: 0px;
    top: 400px;
    width: 139px;
    height: 42px;
    background: #FEEDCB;
    border-radius: 21px 0 0 21px;
    text-align: center;
    >div{
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #89631B;
    }
    >div:first-child{
      padding-top: 4px;
    }
    >img{
      width: 64px;
      height: 88px;
    }
  }
  .lawyer-video{
    width: 100%;
    height: 78px;
    height: 96px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    >div{
      float: left;
      height: 100%;
    }
    .video-img{
      width: 105px;
      height: 66px;
      margin-left: 16px;
      margin-top: 4px;
      width: 124px;
      height: 93px;
      margin-left: 16px;
      // margin-top: 4px;
      >img{
        width: 100%;
        height: 100%;
      }
    }
    .video-text{
      padding-left: 30px;
      padding-top: 17px;
      padding-top: 25px;
      box-sizing: border-box;
      .face{
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .one{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 3px;
        .consulting{
          width: 51px;
          height: 17px;
          background: #CA9636;
          border-radius: 10px;
          text-align: center;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 17px;
          margin-left: 4px;
          float: right;
          margin-top: 1px;
        }
      }
    }
  }
  .newPeople{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2011;
    text-align: center;
    .newPeople_box{
      width: 100%;
      padding: 0 $padding;
      box-sizing: border-box;
      margin-top: 212px;
      font-size: 0;
      .yd1{
        width: 100%;
      }
      .line{
        width: 12px;
      }
    }
    .line{
      width: 12px;
    }
    .newPeople_box2{
      padding: 0 7px;
      margin-top: 57px;
    }
    .newPeople_bg{
      width: 280px;
      height: 78px;
      margin: 3px auto 0;
      background: url(https://cdn.51ljb.cn/ljb_icon_yd_bg.png);
      background-size: cover;
      >p{
        font-size: 15px;
        font-weight: 400;
        color: #89631B;
      }
      p:first-child{
        padding-top: 30px;
      }
    }
    .newPeople_button{
      margin-top: $padding;
      >div{
        width: 72px;
        height: 26px;
        border-radius: 5px;
        line-height: 26px;
        text-align: center;
        font-size: 12px;
        display: inline-block;
      }
      .close{
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        color: #FFFFFF;
        margin-right: $padding;
      }
      .next{
        background: #FFFFFF;
        color: #333333;
        >a{
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue